import React from "react";
import { FaGem, FaUser, FaGear, FaChartColumn } from "react-icons/fa6";
import { Container } from "../home/ui";
import WebSectionHead, { CtaButton } from "./WebSectionHead";

const reasons = [
  { icon: FaGem, title: "Tailored Solutions", text: "Custom websites aligned with your business goals.", tone: "bg-[#E3F0FF] text-[#1E6BFF]" },
  { icon: FaUser, title: "User-Centered Design", text: "Clean, modern, and conversion-focused.", tone: "bg-[#E6EBFF] text-[#2F54EB]" },
  { icon: FaGear, title: "Latest Technologies", text: "Scalable, secure, and future-ready solutions.", tone: "bg-[#F1E6FF] text-[#8B2CF5]" },
  { icon: FaChartColumn, title: "Ongoing Support", text: "Continuous improvements and reliable support.", tone: "bg-[#E3F7EC] text-[#16A34A]" },
];

const WhyChooseWeb = () => (
  <section className="bg-gradient-to-b from-[#F7F9FF] to-white py-[10px] lg:py-[69px]">
    <Container>
      <WebSectionHead
        title="Why Choose Datametricks"
        highlight="for Website Development?"
        br
        subtitle="We combine strategy, design, and technology to create websites that not only look great but also deliver real business results."
        cta={<CtaButton href="/contact-us">Let&apos;s Talk</CtaButton>}
      />
      <div className="mt-[32px] grid gap-[20px] sm:grid-cols-2 lg:grid-cols-4">
        {reasons.map((r) => (
          <div
            key={r.title}
            className="rounded-[18px] border-[1px] border-solid border-[#EEF1F8] bg-white p-[24px] shadow-[0_12px_34px_-20px_rgba(40,60,140,0.25)] transition hover:-translate-y-1"
          >
            <span className={`inline-flex h-[52px] w-[52px] items-center justify-center rounded-[14px] text-[22px] ${r.tone}`}>
              <r.icon />
            </span>
            <h3 className="mt-[22px] text-[17px] font-semibold text-ink">{r.title}</h3>
            <p className="mt-[8px] text-[14.5px] leading-[1.5] text-slate-500">{r.text}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default WhyChooseWeb;
